import {prop, html, clone, traverse, attr, effect, class_toggle, on, append, css, define} from "@intrnl/velvet/internal";
import {createEventDispatcher} from '@intrnl/velvet';
let template0 = html("<div class=score> <button value=1>1</button> <button value=2>2</button> <button value=3>3</button> <button value=4>4</button> <button value=5>5</button> <button value=6>6</button> <button value=7>7</button> <button value=8>8</button> <button value=9>9</button> <button value=10>10</button> </div>");
let style0 = css(".score{display:grid;grid-auto-flow:column;grid-auto-columns:36px;grid-auto-rows:36px;justify-content:space-around}.button{cursor:pointer;user-select:none;background-color:#e8e8f8;font-weight:600;border:0;border-radius:50%}.button:hover{background-color:#cecede}.button.selected{color:#fff;background-color:#4c4cc8}");
function setup($$root, $$host) {
  const emit = createEventDispatcher();
  let value = prop(0, null);
  function handleScoreClick(ev) {
    const raw = ev.target.value;
    if (raw) {
      const value = parseInt(raw);
      emit('update:value', value);
    }
  }
  let fragment0 = clone(template0);
  let child0 = traverse(fragment0, [0, 1]);
  let child1 = traverse(fragment0, [0, 3]);
  let child2 = traverse(fragment0, [0, 5]);
  let child3 = traverse(fragment0, [0, 7]);
  let child4 = traverse(fragment0, [0, 9]);
  let child5 = traverse(fragment0, [0, 11]);
  let child6 = traverse(fragment0, [0, 13]);
  let child7 = traverse(fragment0, [0, 15]);
  let child8 = traverse(fragment0, [0, 17]);
  let child9 = traverse(fragment0, [0, 19]);
  let child10 = traverse(fragment0, [0]);
  attr(child0, "class", "button");
  effect(() => class_toggle(child0, "selected", value.v === 1));
  attr(child1, "class", "button");
  effect(() => class_toggle(child1, "selected", value.v === 2));
  attr(child2, "class", "button");
  effect(() => class_toggle(child2, "selected", value.v === 3));
  attr(child3, "class", "button");
  effect(() => class_toggle(child3, "selected", value.v === 4));
  attr(child4, "class", "button");
  effect(() => class_toggle(child4, "selected", value.v === 5));
  attr(child5, "class", "button");
  effect(() => class_toggle(child5, "selected", value.v === 6));
  attr(child6, "class", "button");
  effect(() => class_toggle(child6, "selected", value.v === 7));
  attr(child7, "class", "button");
  effect(() => class_toggle(child7, "selected", value.v === 8));
  attr(child8, "class", "button");
  effect(() => class_toggle(child8, "selected", value.v === 9));
  attr(child9, "class", "button");
  effect(() => class_toggle(child9, "selected", value.v === 10));
  on(child10, "click", handleScoreClick);
  append($$root, fragment0);
}
export default define("x-score-selector", setup, {
  value: 0
}, [style0]);
